module.exports = __webpack_public_path__ + "img/glasses-8-7.3b099fe4.svg";